import React from 'react';
// Экран падения оформлен как оверлей разрыва связи — те же классы
import '../ConnectionLostOverlay/ConnectionLostOverlay.css';
import {sendErrorEvent} from '../../analytics/gameAnalytics';

/**
 * Последний рубеж: если рендер упал, игрок вместо белого экрана получает
 * объяснение и кнопку перезагрузки, а мы — событие об ошибке в GameAnalytics.
 *
 * До этого падения на проде были полностью невидимы: у человека пустая
 * страница, а в статистике он выглядит обычным пользователем, который «зашел и
 * ничего не нажал».
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] render failed', error, errorInfo?.componentStack);
    sendErrorEvent(error?.message || String(error), true);
  }

  handleReload = () => {
    window.__skipBeforeUnload = true;
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="connection-lost-overlay">
        <h2 className="connection-lost-title">Что-то пошло не так</h2>
        <p className="connection-lost-text">
          Приложение не смогло продолжить работу. Перезагрузите страницу — состояние матча
          восстановится с сервера.
        </p>
        <button className="connection-lost-button" onClick={this.handleReload}>
          Перезагрузить страницу
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
